import React from 'react';
import ReportCodes from '../../../components/reports/ReportCodes';
import PageNumberReport from '../../components/PageNumberReport';

const Haftungsvolumen = () => {
    return <PageNumberReport title="Haftungsvolumen" reportCode={ReportCodes.LiabilityVolume} valueSuffix="€" />;
};

export default Haftungsvolumen;
